module.exports = __webpack_public_path__ + "img/sharebear.a80f47ed.webp";